import LocalStorageService from 'Common/services/LocalStorageService';
import {OnlineReportType} from 'OnlineReport/components/shared/OnlineReportType';
import {REPORT_TYPE_KEY} from './getApiByReportType';

export function setOnlineReportTypeToStorage(onlineReportType: OnlineReportType) {
  LocalStorageService.setItem(REPORT_TYPE_KEY, onlineReportType);
}
